import React from "react";
import { ArrowImg, ProAfter, ProBefore } from "../constant";
import "../assets/css/login.css";
import Header from "../component/Header";

const Login = () => {
  return (
    <>
      <Header />
      <section className="login">
        <div className="before">
          <figure>
            <img src={ProBefore} className="img-fluid" alt="" />
          </figure>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-3" />
            <div className="col-md-6">
              <div className="auth-box">
                <div className="heading">
                  <h2>Sign In</h2>
                  <h4>
                    Welcome back to <span className="bld">Kigi Nursery</span>
                  </h4>
                  <p>
                    Not a Member ?<a href="register">Sign Up</a>
                  </p>
                </div>
                <form action="profile">
                  <div className="form-group">
                    <label>Email</label>
                    <input type="email" className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>Password</label>
                    <input type="password" className="form-control" />
                  </div>
                  <div className="remember-dv">
                    <div className="form-group">
                      <input
                        type="checkbox"
                        id="Remember"
                        className="form-check-input"
                      />
                      <label htmlFor="Remember">Remember Me</label>
                    </div>
                    <div className="link">
                      <a href="forgot">Forgot Password ?</a>
                    </div>
                  </div>
                  <button className="btn" type="submit">
                    <span>Sign in</span>{" "}
                    <img src={ArrowImg} className="img-fluid" alt="" />
                  </button>
                </form>
              </div>
            </div>
            <div className="col-md-3" />
          </div>
        </div>
        <div className="after">
          <figure>
            <img src={ProAfter} className="img-fluid" alt="" />
          </figure>
        </div>
      </section>
    </>
  );
};

export default Login;
